/* global themeVars */

document.querySelectorAll( '.b-advanced-post-list' ).forEach( ( block ) => {

	const clearButton = block.querySelector( '.js-clear-button' );
	const searchButton = block.querySelector( '.js-search-button' );
	const searchInput = block.querySelector( '.js-search-input' );
	const activeFilters = block.querySelector( '.current-filters' );
	const postsFiltersContainer = block.querySelector( '.posts-filters' );
	const postType = postsFiltersContainer?.dataset.postType;
	const paginationContainer = block.querySelector( '.posts-pagination' );
	const postsPerPage = paginationContainer?.dataset.perPage;
	const paginationBaseUrl = paginationContainer?.dataset.baseUrl;
	let filters = [];
	let currentPage = 1;

	/**
	 * Returns current page inferred from URL/path, query string, or active pagination element.
	 *
	 * @return {number}
	 */
	const resolveCurrentPage = () => {

		const pathMatch = window.location.pathname.match( /\/page\/(\d+)\/?$/ );
		if ( pathMatch?.[ 1 ] ) {

			return parseInt( pathMatch[ 1 ], 10 ) || 1;

		}

		const queryPage = new URLSearchParams( window.location.search ).get( 'paged' );
		if ( queryPage ) {

			return parseInt( queryPage, 10 ) || 1;

		}

		const activePageElement = block.querySelector( '.js-posts-pagination .page-numbers.current' );
		if ( activePageElement ) {

			return parseInt( activePageElement.textContent, 10 ) || 1;

		}

		return 1;

	};

	currentPage = resolveCurrentPage();

	/**
	 * Builds canonical page URL for history updates.
	 *
	 * @param {number} page
	 * @return {string|null}
	 */
	const getPageUrl = ( page ) => {

		if ( ! paginationBaseUrl ) {

			return null;

		}

		const baseUrl = new URL( paginationBaseUrl, window.location.origin );
		baseUrl.pathname = baseUrl.pathname.replace( /\/page\/\d+\/?$/, '/' );
		baseUrl.searchParams.delete( 'paged' );

		if ( page > 1 ) {

			baseUrl.pathname = `${ baseUrl.pathname.replace( /\/+$/, '' ) }/page/${ page }/`;

		}

		return baseUrl.toString();

	};

	/**
	 * Attaches a click listener to the search button and search input to add or update a search filter and reload posts via AJAX.
	 *
	 * @return {void}
	 */
	const handleSearch = () => {

		if ( ! searchButton || ! searchInput ) {

			return;

		}

		searchButton.addEventListener( 'click', () => {

			manageSearchFilters();

		} );

		searchInput.addEventListener( 'keydown', ( e ) => {

			if ( e.key === 'Enter' ) {

				e.preventDefault();
				manageSearchFilters();

			}

		} );

	}

	/**
	 * Adds or updates the active search filter based on the input value and reloads posts via AJAX.
	 *
	 * @return {void}
	 */
	const manageSearchFilters = () => {

		const searchPhrase = searchInput.value;

		if ( ! searchPhrase ) {

			return;

		}

		// checks if selected filter is on active filters list
		const matches = filters.filter( ( filter ) => filter.type === 'search' );

		if ( matches.length < 1 ) {

			// adds active search filter
			const filterTag = document.createElement( "span" );
			filterTag.innerText = searchPhrase;
			filterTag.classList = 'js-current-filter';
			filterTag.dataset.searchPhrase = searchPhrase;
			filterTag.dataset.filterType = 'search';

			activeFilters.appendChild( filterTag );

			filters.push( { type: 'search', searchPhrase: searchPhrase } );

		} else {

			// updates active search filter
			const currentFilter = activeFilters.querySelector( 'span[data-filter-type="search"]' );
			const updatedFilters = filters.map( ( filter ) => {

				if ( filter.type === 'search' ) {

					filter.searchPhrase = searchPhrase;

				}

				return filter;

			} );

			currentFilter.textContent = searchPhrase;
			filters = updatedFilters;

		}

		searchInput.value = '';
		currentPage = 1;
		loadAjax();

	}

	/**
	 * Attaches click listeners to taxonomy filters, adds selected ones to the active filters list, and reloads posts via AJAX.
	 *
	 * @return {void}
	 */
	const addActiveFilter = () => {

		const availableFilters = block.querySelectorAll( '.taxonomy-filters' );

		if ( availableFilters.length < 1 ) {

			return;

		}

		availableFilters.forEach( availableFiltersContainer => {

			availableFiltersContainer.addEventListener( 'click', ( e ) => {

				const selectedFilter = e.target.closest( '.js-taxonomy-filter' );
				const filterId = selectedFilter?.dataset.termId;
				const taxonomy = availableFiltersContainer.dataset.taxonomy;

				if ( ! selectedFilter || ! filterId || ! taxonomy ) {

					return;

				}

				// checks if selected filter is on active filters list
				const matches = filters.filter( ( filter ) => filter.id === filterId );

				if ( matches.length < 1 ) {

					selectedFilter.classList.add( 'taxonomy-filter--active' );

					// adds active filter
					const filterTag = document.createElement( "span" );
					filterTag.innerText = selectedFilter.textContent || '';
					filterTag.classList = 'js-current-filter';
					filterTag.dataset.termId = filterId;
					filterTag.dataset.taxonomy = taxonomy;
					filterTag.dataset.filterType = 'taxonomy';

					activeFilters.appendChild( filterTag );

					filters.push( { type: 'taxonomy', id: filterId, taxonomy: taxonomy } );

				}

				currentPage = 1;
				loadAjax();

			} );

		} );

	}

	/**
	 * Attaches a click listener to active filters to remove them individually and reload posts via AJAX.
	 *
	 * @return {void}
	 */
	const removeActiveFilter = () => {

		if ( ! activeFilters ) {

			return;

		}

		activeFilters.addEventListener( 'click', ( e ) => {

			const activeFilter = e.target.closest( '.js-current-filter' );

			if ( !activeFilter ) {

				return;

			}

			const filterType = activeFilter.dataset.filterType;

			// removes active filter
			if ( filterType === 'taxonomy' ) {

				const filterId = activeFilter.dataset.termId;
				const activeTaxonomy = postsFiltersContainer.querySelector( `li[data-term-id="${filterId}"]` );
				const updatedFilters = filters.filter( ( filter ) => ! ( filter.id === filterId ) );
				activeTaxonomy.classList.remove( 'taxonomy-filter--active' );
				filters = updatedFilters;

			} else if ( filterType === 'search' ) {

				const updatedFilters = filters.filter( ( filter ) => ! ( filter.searchPhrase === activeFilter.textContent ) );
				filters = updatedFilters;

			}

			activeFilter.remove();
			currentPage = 1;
			loadAjax();

		} );

	}

	/**
	 * Attaches a click listener to the clear button that resets all filters and reloads posts via AJAX.
	 *
	 * @return {void}
	 */
	const clearAllFilters = () => {

		if ( ! clearButton ) {

			return;

		}

		clearButton.addEventListener( 'click', () => {

			const activeTaxonomies = postsFiltersContainer.querySelectorAll( '.taxonomy-filter--active' );
			if ( activeTaxonomies.length > 0 ) {

				activeTaxonomies.forEach( activeTaxonomy => {

					activeTaxonomy.classList.remove( 'taxonomy-filter--active' );

				} )

			}
			activeFilters.textContent = '';
			filters = [];
			currentPage = 1;
			loadAjax();

		} );

	}

	/**
	 * Performs an AJAX request to load filtered posts and update the pagination dynamically.
	 *
	 * @return {void}
	 */
	const loadAjax = () => {

		fetch( themeVars.ajaxUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams( {
				action: `load_filtered_posts`,
				n: themeVars.security,
				paged: currentPage,
				perPage: postsPerPage || 8,
				baseUrl: paginationBaseUrl || window.location.href,
				filters: JSON.stringify( filters ),
				postType: postType,
			} ),
		} ).then( ( response ) => {

			return response.json();

		} ).then( ( response ) => {

			if ( response.success && response.data?.output !== undefined ) {

				const postsContainer = block.querySelector( '.posts-container' );
				const paginationNode = block.querySelector( '.posts-pagination' );

				if ( postsContainer ) {

					const range = document.createRange();
					const fragment = range.createContextualFragment( response.data.output );
					postsContainer.textContent = '';
					postsContainer.appendChild( fragment );

				}

				if ( paginationNode ) {

					const paginationRange = document.createRange();
					const paginationFragment = paginationRange.createContextualFragment( response.data.pagination );
					paginationNode.textContent = '';
					paginationNode.appendChild( paginationFragment );

					const currentUrl = getPageUrl( currentPage );
					if ( currentUrl ) {

						window.history.pushState( { page: currentPage }, '', currentUrl );

					}

					window.scrollTo( {
						top: block.offsetTop,
						behavior: 'instant'
					} );

				}

			}

		} ).catch( () => {

			// console.log( 'Error parsing JSON:', error );

		} );

	}

	/**
	 * Attaches a click listener to pagination links and updates the current page via AJAX.
	 *
	 * @return {void}
	 */
	const handleAjaxPagination = () => {

		const pagination = block.querySelector( '.js-posts-pagination' );

		if ( !pagination ) {

			return;

		}

		pagination.addEventListener( 'click', ( e ) => {

			e.preventDefault();
			const number = e.target.closest( '.page-numbers' );
			if ( number ) {

				if ( number.classList.contains( 'prev' ) ) {

					currentPage -= 1;

				} else if ( number.classList.contains( 'next' ) ) {

					currentPage += 1;

				} else {

					currentPage = parseInt( e.target.textContent ) || 1;

				}

				loadAjax();

			}

		} );

	}

	handleSearch();
	addActiveFilter();
	removeActiveFilter();
	clearAllFilters();
	handleAjaxPagination();

} );
